import { Autocomplete, Box, Button, CircularProgress, Grid, TextField, } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import Header from 'components/Header';
import { useDispatch, useSelector } from 'react-redux';
import { BasePathProvider, useBasePath } from 'components/Providers';
import { useTranslation } from 'react-i18next';
import { getSubs, save } from 'store/substitute/substitute-portal';
import * as snackbar from '../../../../utils/snackbar'
import { useNavigate } from 'react-router-dom';

export default function AssignSubForm({ date, record }) {
    const dispatch = useDispatch();
    const basePath = useBasePath();
    const { t } = useTranslation();
    const availableSubstitutes = useSelector(state => state.substitutePortal.substitute.subs)
    const navigate = useNavigate()

    const defaultValues = record.periods.reduce((acc, period) => {
        const defaultSubstitute = availableSubstitutes.find(sub => sub.substituteId === period.substituteId);
        acc[period.id] = defaultSubstitute || null; 
        return acc;
    }, {});

    const { control, handleSubmit, formState: { isDirty, isSubmitting } } = useForm({
        defaultValues
    });

    const onSubmit = async (data) => {
        const submissions = record.periods.map(period => {
            const selectedSub = data[period.id]

            return {
                periodId: period.id,
                substituteId: selectedSub ? selectedSub.substituteId : null,
                substituteType: selectedSub ? selectedSub.substituteType || "" : "",
            }
        })

        const payload = {
            date,
            personId: record.personId,
            submissions
        }

        try {
            await dispatch(save(payload))
            await dispatch(getSubs({ date }))
            navigate(basePath)
        } catch (error) {
            snackbar.error('Error Saving! Please try again later')
        }
    };


    return (
        <BasePathProvider value={`${basePath}/substitute-portal`}>
            <Header title={`Coverage for ${record.lastName}, ${record.firstName}`} small close borderBottom />

            <Box data-component='AssignSubForm' component="form" onSubmit={handleSubmit(onSubmit)} mt={1} p={2}>
                <Grid container spacing={1.5}>
                    {record.periods.map((period) => (
                        <Grid item xs={12} key={period.id}>
                            <Controller
                                name={`${period.id}`}
                                control={control}
                                defaultValue={''}
                                render={({ field }) => (
                                    <Autocomplete
                                        {...field}
                                        options={availableSubstitutes}
                                        getOptionLabel={(option) => option?.substituteName || ""}
                                        isOptionEqualToValue={(option, value) => option.substituteId === value?.substituteId}
                                        onChange={(_, value) => field.onChange(value)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={period?.courseSessionName}
                                                variant='outlined'
                                                size='small'
                                            />  
                                        )}
                                        value={field.value || null}
                                    />  
                                )}
                            />
                        </Grid>
                    ))}
                </Grid>

                <Box mt={3} textAlign="right">
                    <Button
                        variant="contained"
                        onClick={handleSubmit(onSubmit)}
                        disabled={isSubmitting || !isDirty}
                        startIcon={isSubmitting && <CircularProgress size={20} />}
                    >
                        {t("Save")}
                    </Button>
                </Box>
            </Box>
        </BasePathProvider>
    );
}
